module.exports = __webpack_public_path__ + "img/pleasure-icon-2.00b81543.svg";